<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M10,10C10,10.55,10.45,11,11,11C11,11,15,11,15,11C15.55,11,16,10.55,16,10C16,9.45,15.55,9,15,9C15,9,11,9,11,9C10.45,9,10,9.45,10,10C10,10,10,10,10,10ZM6,7C6,7.55,6.45,8,7,8C7,8,11,8,11,8C11.55,8,12,7.55,12,7C12,6.45,11.55,6,11,6C11,6,7,6,7,6C6.45,6,6,6.45,6,7C6,7,6,7,6,7ZM15,12C15,12,2,12,2,12C2,12,2,3,2,3C2,2.45,1.55,2,1,2C0.45,2,0,2.45,0,3C0,3,0,13,0,13C0,13.55,0.45,14,1,14C1,14,15,14,15,14C15.55,14,16,13.55,16,13C16,12.45,15.55,12,15,12C15,12,15,12,15,12ZM4,5C4,5,7,5,7,5C7.55,5,8,4.55,8,4C8,3.45,7.55,3,7,3C7,3,4,3,4,3C3.45,3,3,3.45,3,4C3,4.55,3.45,5,4,5C4,5,4,5,4,5Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'GanttChart',
} as DefineComponent
</script>
